import React, { useState } from "react";
import { connect } from "react-redux";

import Modal from "react-responsive-modal";
import { Button, Input } from "@revvsales/components";
import PropTypes from "prop-types";

import { GlobalUtils } from "../../../utils";

const { writeDataToLocalStorage, readDataFromLocalStorage } = GlobalUtils;

const OnboardModal = ({
  isOpen,
  toggleModal,
  toggleDropdown,
  toolpaneIsOpen,
  dataObject,
  onBoardingSource,
}) => {
  const [dontShowIsChecked, setDontShowIsChecked] = useState(false);

  const _setDontShow = (type, event) => {
    const localData = readDataFromLocalStorage("onBoardingData");
    writeDataToLocalStorage("onBoardingData", {
      ...localData,
      [type]: !event.target.checked,
    });
    setDontShowIsChecked(event.target.checked);
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        toggleModal(false);
      }}
      // container={this.metalensIconRef.current}
      classNames={{
        modal: `metalens-tutorial-modal ${
          toolpaneIsOpen
            ? "metalens-tutorial-modal-center"
            : "metalens-tutorial-modal-side"
        }`,
        overlay: "metalens-tutorial-modal-overlay",
      }}>
      <div className="metalens-tutorial-head-container">
        <span aria-label="revv-ai-bolt" role="img">
          ⚡
        </span>{" "}
        {dataObject.caption ? dataObject.caption : ""}
      </div>
      <div className="metalens-tutorial-gif-container">
        <img className="metalens-tutorial-gif" src={dataObject.gif} alt="" />
      </div>
      <div className="metalens-tutorial-info onboardmodal-tutorial-info">
        {dataObject.description}
      </div>
      <Button
        data-test="metalens-tutorial-try"
        data-from="metalens-tutorial"
        className="metalens-tutorial-btn"
        onClick={event => {
          toggleModal(false);
          if (toggleDropdown) {
            toggleDropdown(event);
          }
        }}>
        {dataObject.buttonText}
      </Button>
      <div className="metalens-tutorial-checkbox-container">
        <Input
          data-test="metalens-input-dontshow"
          checked={dontShowIsChecked}
          type="checkbox"
          value=""
          onChange={e => _setDontShow(onBoardingSource, e)}
          disabled={false}
          className="metalens-tutorial-checkbox"
        />
        <span className="metalens-tutorial-checkbox-text">
          Don&#39;t show again
        </span>
      </div>
    </Modal>
  );
};

OnboardModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ToolPaneStore: { isOpen: toolpaneIsOpen } }) => ({
  toolpaneIsOpen,
});

export default connect(mapStateToProps)(OnboardModal);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/OnboardModal/index.js